<template>
    <router-link id="campaigns-table-campaign-name-button" class="campaign-title-link" :to="{ name: 'campaigns-insights', params: { id: params.data.id } }">
          {{ params.data.name }}
    </router-link>
</template>
<script>
export default {}
</script>

<style lang="scss" scoped>

    .campaign-title-link {
      white-space: initial;
      display: inline-block;
      word-wrap: break-word;
      line-height: 19px;
      max-width: 350px;
      padding: 15px 15px 15px 0;
    }

</style>
